import { BaseWebComponentRepository } from '../../../../framework/BaseWebComponentRepository';
import { SchemaHelperWebComponentSchema } from '../types';
import { SchemaHelperViewDataProvider } from '../dataProvider/SchemaHelperViewDataProvider';
import { SchemaHelperDataProviderFactory } from '../factory/SchemaHelperDataProviderFactory';

export default class SchemaHelperRepository extends BaseWebComponentRepository {
  public dataProviderFactory: SchemaHelperDataProviderFactory;
  public dataProvider: SchemaHelperViewDataProvider;

  constructor() {
    super();

    this.initialSetup({
      dataProviderFactory: new SchemaHelperDataProviderFactory(),
    });
  }

  public async getDataForView(): Promise<SchemaHelperWebComponentSchema> {
    return await this.dataProvider.getDataForView();
  }
}
